import React from "react";
import ControlDetailsPanel from "./ControlDetailsPanel";
import ValueTable, { TValueItem } from "./ValueTable";
import { IControlBoschDevice, TBoschValueAttribute } from "../types";

interface IControlDetailsBoschDeviceProps {
  control: IControlBoschDevice;
}

const ControlDetailsBoschDevice = (props: IControlDetailsBoschDeviceProps) => {
  const { control } = props;
  const items: TValueItem<TBoschValueAttribute>[] = [
    { name: "Status", attribute: "status" },
    { name: "Remaining Time", attribute: "remaining_time" },
    { name: "Door State", attribute: "door_state" },
    { name: "Active Program", attribute: "active_program" },
    { name: "Operation State", attribute: "operation_state" },
    { name: "Program Progress", attribute: "program_progress" },
  ];
  return (
    <ControlDetailsPanel
      mode={control.is_enabled ? "on" : "disabled"}
      title={control.name}
    >
      <ValueTable control={control} items={items} />
    </ControlDetailsPanel>
  );
};

export default ControlDetailsBoschDevice;
